// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PullRequestOutlinedSvg from "@ant-design/icons-svg/es/asn/PullRequestOutlined";
import AntdIcon from '../components/AntdIcon';

var PullRequestOutlined = function PullRequestOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PullRequestOutlinedSvg
  }));
};

PullRequestOutlined.displayName = 'PullRequestOutlined';
export default React.forwardRef(PullRequestOutlined);